var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 1.33301C4.3206 1.33301 1.33594 4.31767 1.33594 7.99967C1.33594 11.6817 4.3206 14.6663 8.0026 14.6663C11.6846 14.6663 14.6693 11.6817 14.6693 7.99967C14.6693 4.31767 11.6846 1.33301 8.0026 1.33301ZM10.1979 11.1377L7.33594 8.27567V3.99967H8.66927V7.72367L11.1406 10.195L10.1979 11.1377Z",
    fill: "#48484A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFill);
export default __webpack_public_path__ + "static/media/clock-fill.321e960ef68fb3e8b3209cb112f3a6bb.svg";
export { ForwardRef as ReactComponent };